import React from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';

const tabs = [
  { to: 'customer-lookup', label: 'Customer Lookup', icon: 'bi-search' },
  { to: 'current-bill', label: 'Current Bill', icon: 'bi-receipt' },
  { to: 'collect-payment', label: 'Collect Payment', icon: 'bi-credit-card' },
  { to: 'billing-history', label: 'Billing History', icon: 'bi-clock-history' },
  { to: 'payment-plans', label: 'Payment Plans', icon: 'bi-calendar-check' }
];

const BillingLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    // Redirect bare /billing to /billing/customer-lookup
    if (location.pathname.match(/\/billing\/?$/)) {
      navigate('customer-lookup', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <>
      <PageHeader
        eyebrow="Utility Billing"
        title="Billing"
        description="Process customer payments, review balances, and manage billing operations across the TriServe account portfolio."
        icon="credit-card"
        iconTone="success"
        className="mb-4"
      />

      <div className="card border-0 shadow-sm mb-4 billing-nav-card">
        <div className="card-header bg-tse-primary text-white border-0 billing-nav-card__header">
          <div className="d-flex align-items-center">
            <i className="bi bi-lightning-charge me-2"></i>
            <span className="fw-bold">TriServe Energy</span>
            <span className="ms-2 opacity-75">Billing Management System</span>
          </div>
        </div>
        <div className="card-body p-0 billing-nav-card__body">
          <ul className="nav nav-tabs border-0 billing-nav-tabs" role="tablist" aria-label="Billing feature sections">
            {tabs.map(t => {
              const isActive = location.pathname.endsWith(t.to);
              const tabId = `billing-tab-${t.to}`;
              const panelId = `billing-panel-${t.to}`;
              return (
                <li className="nav-item billing-nav-tabs__item" role="presentation" key={t.to}>
                  <NavLink
                    id={tabId}
                    to={t.to}
                    className={({ isActive }) =>
                      'nav-link d-flex align-items-center px-4 py-3 billing-nav-tabs__link' + (isActive ? ' active' : '')
                    }
                    role="tab"
                    aria-selected={isActive}
                    aria-controls={panelId}
                    data-testid={tabId}
                  >
                    <span className="billing-nav-tabs__icon" aria-hidden="true">
                      <i className={`bi ${t.icon}`}></i>
                    </span>
                    <span className="billing-nav-tabs__label">{t.label}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <Outlet />
    </>
  );
};

export default BillingLayout;
